import { useMemo } from 'react'

import { useApiClient } from 'clients/yogi-api'
import { ProjectFormService } from 'features/project-form/service/service'

export { ProjectFormService } from 'features/project-form/service/service'

export function useProjectFormService(): ProjectFormService {
  const client = useApiClient()
  return useMemo(() => new ProjectFormService(client), [client])
}
